import { ConsoleNetworkIcon } from './ConsoleNetworkIcon';

/**
 * author: Michael Richins
 * id 19A41CF5-CA4E-411C-8C34-14895B4B90DD
 * name console-network
 * version: 2.2.43
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/console-network.svg
 * tags
 */
export const TerminalNetworkIcon = ConsoleNetworkIcon;
export default TerminalNetworkIcon